<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-multiple"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("People") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'person.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
      >
        <template v-slot:item.childrens="{ item }">
          {{ item.childrens_length }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="showItem(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></v-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";

export default {
  name: "app-person-list",
  data() {
    return {
      loading: true,
      options: {},
      total: 0,
      search: "",
      items: []
    };
  },

  created() {
    this.getData();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("first_name"),
          align: "left",
          value: "first_name"
        },
        {
          text: this.$t("last_name"),
          align: "left",
          value: "last_name"
        },
        {
          text: this.$t("tax"),
          align: "left",
          value: "tax"
        },
        {
          text: this.$t("Children"),
          align: "left",
          value: "childrens"
        },
        { text: "", value: "action", sortable: false }
      ];
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Person?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "person.edit", params: { id: url } });
    },
    showItem(item) {
      let url = item.id;
      this.$router.push({
        name: "person.show",
        params: { id: url, edit: false }
      });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
